import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-ec-return-reason-modal',
  templateUrl: './ec-return-reason-modal.page.html',
  styleUrls: ['./ec-return-reason-modal.page.scss'],
})
export class EcReturnReasonModalPage implements OnInit {
  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
